import config from '@/preload/data/config.json'
import { usePage, useBlogPage, useHead } from '#imports'

export default function () {
  const page = usePage()
  const { isBlogPage, blogCategory } = useBlogPage()

  let individualMeta = null
  let individualTitle = ''

  if (page) {
    individualMeta = page.categories?.metaDescription
    individualTitle = page.title
  }

  if (isBlogPage) {
    individualMeta = blogCategory.metaDescription
    individualTitle = blogCategory.title
  }

  const head = {
    title: individualTitle ? `${config.pagetitle} | ${individualTitle}` : config.pagetitle,
  }

  if (individualMeta) {
    head.meta = [
      { name: 'description', content: individualMeta }
    ]
  }

  useHead(head)
}
